<template>
  <div class="container-progress" id="container-hValueProgress">
    <canvas
      :id="canvasId"
      :style="{ width: width + 'px', height: height + 'px' }"
    ></canvas>
  </div>
</template>

<script>
//   currentValue= 580
//   perfectValue= 900
//   :levelValues='[0,405,491,577,750,836,922,1000]'
//   :levels="['极差','很差','较差','一般','较好','很好','非常好']"
//   :levelColors="['#72DB2B','#72DB2B', '#C4EE54', '#FCDC71', '#FA9265', '#F7684B', '#C4EE54']"
//   :texts="['健康值等级', '理想健康值', '当前健康值']"

export default {
  name: "compare-progress",
  props: {
    canvasId: {
      type: String,
      default: "canvas-hValueProgress",
    },
    currentValue: {
      type: Number,
      default: 0,
    },
    perfectValue: {
      type: Number,
      default: 0,
    },
    numbers: {
      type: Array,
      default: function () {
        return [0, 405, 491, 577, 750, 836, 922, 1000];
      },
    },
    levels: {
      type: Array,
      default: function () {
        return ["极差", "很差", "较差", "一般", "较好", "很好", "非常好"];
      },
    },
    levelColors: {
      type: Array,
      default: function () {
        // return ['#0E7CE2', '#FF8352', '#E271DE', '#F8456B', '#00FFFF', '#4AEAB0', '#FF8352']
        // return ['#72DB2B','#72DB2B', '#C4EE54', '#C4EE54', '#FCDC71', '#FA9265', '#F7684B']
        return [
          "#F7684B",
          "#FA9265",
          "#FCDC71",
          "#C4EE54",
          "#C4EE54",
          "#72DB2B",
          "#72DB2B",
        ];
      },
    },
    texts: {
      type: Array,
      default: function () {
        return ["健康值等级", "理想健康值", "当前健康值"];
      },
    },
  },
  data() {
    return {
      circleLoading: null,
      process: 0,
      width: 0,
      height: 0,
    };
  },
  created() {
    this.$nextTick(() => {
      this.load();
    });
  },
  watch: {
    currentValue(val) {
      // console.log(val);
      this.load();
    },
  },
  methods: {
    load() {
      let containerProgress = document.getElementById(
        "container-hValueProgress"
      );
      let container = containerProgress.getBoundingClientRect();

      this.width = container.width;
      this.height = container.height;

      let canvas = document.getElementById(this.canvasId);
      // console.log(this.canvasId);
      let context = canvas.getContext("2d");

      let dpr = window.devicePixelRatio; // 假设dpr为2
      // console.log(dpr);
      // let dpr = 3; // 假设dpr为2
      // console.log(dpr);
      // 获取css的宽高
      // let { width: cssWidth, height: cssHeight } = canvas.getBoundingClientRect();
      // console.log(cssWidth,cssHeight);
      // 根据dpr，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等
      canvas.width = dpr * this.width;
      canvas.height = dpr * this.height;

      this.$emit("showWidth", ((this.width - 120) / 5) * 3);

      // /*绘制*/
      // let that = this;
      // this.circleLoading = setInterval(function () {
      //     that.drawCircle(context, canvas, dpr);
      // },20);

      this.drawCircle(context, canvas, dpr);
    },
    drawCircle(context, canvas, dpr) {
      // if (this.process >= this.value) {
      //     clearInterval(this.circleLoading);
      // }

      let center_x = canvas.width / 2;
      let center_y = canvas.height / 2;

      context.clearRect(0, 0, canvas.width, canvas.height);

      let numbers = this.numbers;
      let levels = this.levels;
      let levelColors = this.levelColors;

      context.save();

      let text = this.texts[0];
      let textFont = 14 * dpr;
      context.font = `${textFont}px 微软雅黑`;
      context.textBaseline = "middle";
      context.textAlign = "center";
      context.fillStyle = "#666";

      let measureText = context.measureText(text);
      let textWidth = 120 * dpr;
      let bottomPadding = 45 * dpr;
      context.fillText(text, textWidth / 2, canvas.height - bottomPadding);

      let itemWidth = (canvas.width - 2 * textWidth) / levels.length;
      let font1 = 14 * dpr;

      let font2 = 13 * dpr;

      for (let index = 0; index < numbers.length; index++) {
        if (index < levels.length) {
          context.font = `${font1}px PingFangSC-Regular`;
          context.textBaseline = "middle";
          context.textAlign = "center";
          context.fillStyle = "#666";
          let text = levels[index];
          context.fillText(
            text,
            textWidth + itemWidth / 2 + itemWidth * index,
            canvas.height - font1
          );
        }

        context.font = `${font2}px 微软雅黑`;
        context.fillStyle = "gray";
        let number = numbers[index];
        context.fillText(
          number,
          textWidth + itemWidth * index,
          canvas.height - font1 - font2
        );
      }

      // let font2 = 13*dpr;
      let lineWidth = 10 * dpr;

      let canvasGradient1 = context.createLinearGradient(
        textWidth,
        canvas.height - font1 - font2 - lineWidth * 2,
        canvas.width - textWidth,
        canvas.height - font1 - font2 - lineWidth * 2
      );

      let spaced = 1.0 / levelColors.length;
      levelColors.forEach((item, index) => {
        canvasGradient1.addColorStop(spaced * index, item);
        // console.log(spaced*(index+1));
      });

      context.lineWidth = lineWidth;
      context.strokeStyle = canvasGradient1;
      context.lineCap = "round"; //线段端点的样式
      context.beginPath(); //开始创建路径
      context.moveTo(textWidth, canvas.height - font1 - font2 - lineWidth * 2);
      context.lineTo(
        canvas.width - textWidth,
        canvas.height - font1 - font2 - lineWidth * 2
      );
      context.stroke(); // 进行绘制外边框
      context.closePath(); //结束路径

      let text1 = this.texts[1];
      context.font = `${textFont}px 微软雅黑`;
      context.textBaseline = "middle";
      context.textAlign = "center";
      context.fillStyle = "#666";
      context.fillText(text1, textWidth / 2, canvas.height - bottomPadding * 2);

      let perfectValue = this.perfectValue;
      if (perfectValue < 0) {
        perfectValue = 0;
      }
      if (perfectValue > 1000) {
        perfectValue = 1000;
      }
      let perfectNextIndex = numbers.findIndex((item) => {
        return item >= perfectValue;
      });

      if (perfectNextIndex > -1) {
        // let perfectForwardIndex = perfectNextIndex - 1;

        let forwardIndex = perfectNextIndex - 1;

        let value1 = numbers[forwardIndex];
        let value2 = numbers[perfectNextIndex];

        let offsetWidth =
          ((perfectValue - value1) * itemWidth) / (value2 - value1);

        context.lineWidth = lineWidth;
        context.strokeStyle = canvasGradient1;
        context.beginPath(); //开始创建路径
        context.moveTo(textWidth, canvas.height - bottomPadding * 2);
        context.lineTo(
          textWidth + forwardIndex * itemWidth + offsetWidth,
          canvas.height - bottomPadding * 2
        );
        context.stroke(); // 进行绘制外边框
        context.closePath(); //结束路径
      }

      let text2 = this.texts[2];

      // let measureText2 = context.measureText(text2);
      // let textWidth2 = measureText2.width*2;
      context.fillText(text2, textWidth / 2, canvas.height - bottomPadding * 3);

      let currentValue = this.currentValue;
      if (currentValue < 0) {
        currentValue = 0;
      }
      if (currentValue > 1000) {
        currentValue = 1000;
      }
      let currentNextIndex = numbers.findIndex((item) => {
        return item >= currentValue;
      });

      if (currentNextIndex > -1) {
        // let perfectForwardIndex = perfectNextIndex - 1;

        let forwardIndex = currentNextIndex - 1;

        let value1 = numbers[forwardIndex];
        let value2 = numbers[currentNextIndex];

        let offsetWidth =
          ((currentValue - value1) * itemWidth) / (value2 - value1);

        context.lineWidth = lineWidth;
        context.strokeStyle = canvasGradient1;
        context.beginPath(); //开始创建路径
        context.moveTo(textWidth, canvas.height - bottomPadding * 3);
        context.lineTo(
          textWidth + forwardIndex * itemWidth + offsetWidth,
          canvas.height - bottomPadding * 3
        );
        context.stroke(); // 进行绘制外边框
        context.closePath(); //结束路径
      }
    },
  },
};
</script>

<style scoped>
.container-progress {
  /* background-color: red; */
  box-sizing: border-box;
}
</style>
